//Global Variable Declarations DDP
console.log("Delivery Date Pro product page version");
var base_path_delivery_date = "https://ddp.zestardshop.com/";
var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
var all_settings,cutoff_hours, cutoff_minute, store_hour, store_minute, datepicker_default_date, deliverytime_global_status, app_version, type_of_app, cutoff_global_status, cutoff_status, cutoff_global_hours, cutoff_global_minute, start_from, is_time_required, is_date_required, time_array, time_count, deliverytime_response, cutoff_response, date_formate, add_delivery_information, order_note, locale, date_error_message,time_error_message, store_date, delivery_date_array, formatted_delivery_date, selected_delivery_date, time_in_text, day, dates, product_status;
var xhttp;
var shop_name = Shopify.shop,
    DDP_product_id = product_id;
var $zestard_jq = app_status = "";
var loaderElement = document.querySelector('.ztpl-loader');
//Check if Jquery is Undefined or Not available.
if (typeof jQuery == 'undefined') {
    //If Undefined or Not available, Then Load
    var jscript = document.createElement("script");
    jscript.src = "https://ddp.zestardshop.com/js/zestard_jquery_3.3.1.js";
    jscript.type = 'text/javascript';
    jscript.async = false;

    var el = document.getElementById('datepicker_box'),
        elChild = document.createElement('div');
    elChild.id = 'datepicker_box_jquery';
    el.insertBefore(elChild, el.firstChild);
    document.getElementById('datepicker_box_jquery').append(jscript);

    jscript.onload = function() {
        //Assigning Jquery Object to Zestard_jq
        $zestard_jq = window.jQuery;
        $zestard_jq.ajax({
            url: "https://ddp.zestardshop.com/getconfig",
            dataType: "json",
            async: false,
            data: {
                shop: shop_name
            },
            success: function(data) {
                locale = data.language_locale;
                app_status = data.app_status;
            }
        });
        //If Undefined or Not available, Then Load
        script = document.createElement('script');
        script.type = "text/javascript";
        script.async = false;
        script.src = 'https://ddp.zestardshop.com/js/jquery-ui.js';
        document.getElementById('datepicker_box_jquery').append(script);
        script.onload = function() {
            // Check If jQuery UI Object is Undefined
            //Send Email that jQuery is Still not Working
            if (typeof jQuery.ui == 'undefined') {
                //If undefined then send email
                var jscript_ui = document.createElement("script");
                jscript_ui.src = "https://ddp.zestardshop.com/js/jquery-ui.min.js";
                jscript_ui.type = 'text/javascript';
                jscript_ui.async = false;
                $zestard_jq = window.jQuery;
                //Calling Delivery Date Function
                deliveryDatePro();
            } else {
                if (locale == "en") {
                    $zestard_jq = window.jQuery;
                    //Calling Delivery Date Function
                    deliveryDatePro();
                } else {
                    jscript = document.createElement("script");
                    jscript.src = "https://ddp.zestardshop.com/js/locale_js/datepicker-" + locale + ".js";
                    jscript.type = 'text/javascript';
                    jscript.async = false;
                    var el = document.getElementById('datepicker_box'),
                        elChild = document.createElement('div');
                    elChild.id = 'datepicker_locale_jquery';
                    el.insertBefore(elChild, el.firstChild);
                    el.append(elChild);
                    document.getElementById('datepicker_box_jquery').append(jscript);
                    jscript.onload = function() {
                        $zestard_jq = window.jQuery;
                        //Calling Delivery Date Function
                        deliveryDatePro();
                    }
                }
            }
        }
    };
} else {
    if (typeof jQuery.ui == 'undefined') {
        var jscript_ui = document.createElement("script");
        jscript_ui.src = "https://ddp.zestardshop.com/js/jquery-ui.min.js";
        jscript_ui.type = 'text/javascript';
        jscript_ui.async = false;
        $zestard_jq = window.jQuery;
        var el = document.getElementById('datepicker_box'),
            elChild = document.createElement('div');
        elChild.id = 'datepicker_box_jquery';
        el.insertBefore(elChild, el.firstChild);
        document.getElementById('datepicker_box_jquery').append(jscript_ui);
        //Calling Delivery Date Function
        jscript_ui.onload = function() {
            $zestard_jq = window.jQuery;
            $zestard_jq.ajax({
                url: "https://ddp.zestardshop.com/getconfig",
                dataType: "json",
                async: false,
                data: {
                    shop: shop_name
                },
                success: function(data) {
                    locale = data.language_locale;
                    app_status = data.app_status;
                }
            });
            if (locale == "en") {
                $zestard_jq = window.jQuery;
                //Calling Delivery Date Function
                deliveryDatePro();
            } else {
                jscript = document.createElement("script");
                jscript.src = "https://ddp.zestardshop.com/js/locale_js/datepicker-" + locale + ".js";
                jscript.type = 'text/javascript';
                jscript.async = false;
                var el = document.getElementById('datepicker_box'),
                    elChild = document.createElement('div');
                elChild.id = 'datepicker_locale_jquery';
                el.insertBefore(elChild, el.firstChild);
                el.append(elChild);
                document.getElementById('datepicker_box_jquery').append(jscript);
                jscript.onload = function() {
                    $zestard_jq = window.jQuery;
                    //Calling Delivery Date Function
                    deliveryDatePro();
                }
            }
        }
    } else {
        $zestard_jq = window.jQuery;
        var el = document.getElementById('datepicker_box'),
        elChild = document.createElement('div');
        elChild.id = 'datepicker_box_jquery';
        el.insertBefore(elChild, el.firstChild);
        //Calling Delivery Date Function
        deliveryDatePro();
    }
}

// For error email sending
function fn_exception_occurred_call(shop_name,data){
    var line_number = data?.stack;
    if(line_number == '' || line_number == undefined){
        var line_number = data?.line;
    }
     $zestard_jq.ajax({
        type: "GET",
        url: base_path_delivery_date + "frontendexception",
        async: false,
        data: { shop: shop_name, message: data, file_path: 'product_snippets.js', line_number:line_number },
        success: function(result) {}
    });
}

function deliveryDatePro() {
    try {
        if (loaderElement) {
            loaderElement.classList.add('hide');
        }
        store_date = $zestard_jq("#ztpl-date-format-ddmmyy").val();
        var product_settings, store_settings;
        $zestard_jq.ajax({
            url: "https://ddp.zestardshop.com/get-type-and-version",
            async: false,
            data: { shop_name: shop_name },
            success: function(result) {
                app_version = result.app_version;
                type_of_app = result.type_of_app;
            }
        });
        //delivery date box on Product Page.
        if(app_version == 4){
            $zestard_jq.ajax({
                url: "https://ddp.zestardshop.com/get-product-settings",
                async: false,
                data: { shop_name: shop_name, product_id: DDP_product_id },
                success: function(result) {
                    all_settings = $zestard_jq.parseJSON(result);
                }
            });
        }
        if (app_version != 4 || all_settings == 0 || all_settings == '' || app_status == 'Deactive' || all_settings.product_settings == null) {
            $zestard_jq("#datepicker_box").remove();
            $zestard_jq(".ztpl-product-wrapper").remove();
            $zestard_jq("input[name=add]").css('pointer-events', "auto");
            $zestard_jq("button[name=add]").css('pointer-events', "auto");
            $zestard_jq("#AddToCart").css('pointer-events', "auto");
        } else {
            product_settings = all_settings.product_settings;
            app_config = all_settings.app_config;
            var unavailableDates = [];
            var unavailableDays = [];
            start_from = '';
            var allowed_month = '';
            date_formate = '';
            product_status = product_settings.status;
            var check_out_form = $zestard_jq("#delivery-date-pro").closest("form").attr('class');
            if (check_out_form) {
                var check_out_class_array = check_out_form.split(' ');
                if ($zestard_jq.inArray("cart-form", check_out_class_array) < 0) {
                    $zestard_jq("#delivery-date-pro").closest("form").addClass("cart-form");
                }
            } else {
                $zestard_jq("#delivery-date-pro").closest("form").addClass("cart-form");
            }
            is_date_required = false;
            is_time_required = false;
            $zestard_jq.ajax({
                url: "https://ddp.zestardshop.com/getconfig",
                dataType: "json",
                async: false,
                data: {
                    shop: shop_name
                },
                success: function(data) {
                    app_status = data.app_status;
                    locale = data.language_locale;
                    datepicker_on_default = data.datepicker_display_on;
                    datepicker_default_date = data.default_date_option;
                    add_delivery_information = data.add_delivery_information;
                    date_error_message = data.date_error_message;
                    time_error_message = data.time_error_message;
                    if (app_status == "Deactive") {
                        $zestard_jq("#datepicker_box").remove();
                        $zestard_jq("input[name=add]").css('pointer-events', "auto");
                        $zestard_jq("button[name=add]").css('pointer-events', "auto");
                        $zestard_jq("#AddToCart").css('pointer-events', "auto");
                    }
                    /* If setting are not saved for particular product then use default settings */
                    if (product_settings == null) {
                        $zestard_jq("#datepicker_box").remove();
                        $zestard_jq(".ztpl-product-wrapper").remove();
                        $zestard_jq("input[name=add]").css('pointer-events', "auto");
                        $zestard_jq("button[name=add]").css('pointer-events', "auto");
                        $zestard_jq("#AddToCart").css('pointer-events', "auto");
                    } else {
                        if (product_settings.status == 0) {
                            $zestard_jq("#datepicker_box").remove();
                            $zestard_jq(".ztpl-product-wrapper").remove();
                            data.require_option = 0;
                        }
                        if (app_config.global_product_blocked_dates == 0) {
                            blocked_dates = product_settings.blocked_dates;
                            unavailableDates = blocked_dates.split(",");
                        } else {
                            blocked_dates = data.block_date;
                            unavailableDates = $zestard_jq.parseJSON(blocked_dates);
                        }

                        

                        if (app_config.global_product_blocked_days == 0) {
                            day = product_settings.blocked_days;
                            if (day != null) {
                                unavailableDays = day.split(",");
                            }
                        } else {
                            day = data.days;
                            if (day) {
                                unavailableDays = $zestard_jq.parseJSON(day)
                            }
                        }

                        

                        if (app_config.global_product_date_interval == 0) {
                            start_from = '+' + product_settings.date_interval;
                        } else {
                            start_from = '+' + data.date_interval;
                        }
                        if (app_config.global_product_pre_order == 0) {
                            allowed_month = '+' + product_settings.pre_order_time + 'M';
                        } else {
                            allowed_month = '+' + data.alloved_month + 'M';
                        }
                        if (app_config.global_product_cut_off == 0) {
                            cutoff_global_hours = product_settings.cut_off_hours;
                            cutoff_global_minute = product_settings.cut_off_minutes;
                        } else {
                            cutoff_global_hours = data.hours;
                            cutoff_global_minute = data.minute;
                        }
                        if (app_config.global_product_delivery_time == 0) {
                            time_in_text = product_settings.delivery_times;
                        } else {
                            time_in_text = data.delivery_time;
                        }


                        //newCode product-based-settings

                                    if (product_settings.product_based_settings == 1) {

                                        blocked_dates = product_settings.blocked_dates;
                                        unavailableDates = blocked_dates.split(",");

                                    day = product_settings.blocked_days;
                                                if (day != null) {
                                                    unavailableDays = day.split(",");
                                                }

                                    start_from = '+' + product_settings.date_interval; 
                                    allowed_month = '+' + product_settings.pre_order_time + 'M'; 

                                    cutoff_global_hours = product_settings.cut_off_hours;
                                    cutoff_global_minute = product_settings.cut_off_minutes;  

                                    time_in_text = product_settings.delivery_times;    
                                    }
                                    console.log("cutoff_global_hours + cutoff_global_minute");
                                    console.log(cutoff_global_hours,cutoff_global_minute);
                                    
                            

                        //newCode product-based-settings ends here



                        if (data.require_option == 1) {
                            //console.log('test');
                            is_date_required = true;
                            $zestard_jq("#delivery-date-pro").attr("required", "true");
                            $zestard_jq("#delivery-date-pro").closest("form").removeAttr('novalidate');
                        }
                        var date_label = data.datepicker_label;
                        show_datepicker_label = data.show_datepicker_label;
                        if (show_datepicker_label == 1) {
                            $zestard_jq('.date-box label').text(date_label);
                        } else {
                            $zestard_jq('.date-box label').hide();
                        }
                        time_array = new Array();
                        if (time_in_text) {
                            time_array = time_in_text.split(",");
                        }
                        date_formate = data.date_format;
                        cutoff_status = data.cuttoff_status;
                        cutoff_global_status = data.cutoff_global_status;
                        deliverytime_global_status = data.deliverytime_global_status;
                        var current_date = $zestard_jq("#ztpl-current-date").val();
                        store_hour = $zestard_jq("#ztpl-store-hour").val();
                        store_minute = $zestard_jq("#ztpl-store-minute").val();
                        if (date_formate == "mm/dd/yy") {
                            var display_format = "(mm/dd/yyyy)";
                        } else if (date_formate == "yy/mm/dd") {
                            var display_format = "(yyyy/mm/dd)";
                        } else if (date_formate == "dd/mm/yy") {
                            var display_format = "(dd/mm/yyyy)";
                            date_formate == "dd-mm-yy"
                        } else {
                            var display_format = "(mm/dd/yyyy)";
                        }
                        var show_date_format = data.show_date_format;
                        if (show_date_format == 1) {
                            if (display_format != "") {
                                $zestard_jq("#selected_format").text(display_format);
                            } else {
                                $zestard_jq("#selected_format").text('mm/dd/yyyy');
                            }
                        }
                        var admin_note_status = data.admin_note_status;
                        var notes_admin = data.admin_order_note;
                        if (admin_note_status == 1) {
                            $zestard_jq("#admin_notes").html($zestard_jq.parseHTML(notes_admin));
                        }
                        var admin_time_status = data.admin_time_status;
                        var enable_external_delivery_time = 1;
                        if(data.new_upgrade_status == 1){
                            var enable_external_delivery_time = data.enable_external_delivery_time;
                        }
                        var time_lable = data.time_label;

                        var default_option_label = data.time_default_option_label;
                        if (admin_time_status == 1 && enable_external_delivery_time == 1) {
                            time_count = 0;
                            $zestard_jq("#delivery-time").show();
                            $zestard_jq("#delivery-time").css('border', 'none');
                            $zestard_jq("#time_option_label").text(default_option_label);
                            if (app_version <= 2 && type_of_app <= 2) {
                                $zestard_jq(time_array).each(function() {
                                    $zestard_jq('#delivery-time').append("<option value='" + time_array[time_count] + "'" + ">" + time_array[time_count] + "</option>");
                                    time_count++;
                                });
                            }
                            $zestard_jq("#delivery-time-label").show();
                            $zestard_jq("#delivery-time-label").text(time_lable);
                            if (data.time_require_option == 1) {
                                is_time_required = true;
                                $zestard_jq("#delivery-time").attr("required", "true");
                                $zestard_jq("#delivery-date-pro").closest("form").removeAttr('novalidate');
                            }
                            $zestard_jq("#delivery-time").change(function update_order_delivery_time() {
                                if($zestard_jq("[action='/cart/add']").length > 0){
                                    if (shop_name == "morimoto-gift.myshopify.com"){
                                        $zestard_jq(".delivery-time-hidden").remove();
                                        var ord_del_time = $zestard_jq(this).val().trim();
                                        $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-time-hidden" name="properties[ç´æœŸ]" value="'+ ord_del_time +'">');
                                    }else{
                                        $zestard_jq(".delivery-time-hidden").remove();
                                        var ord_del_time = $zestard_jq(this).val().trim();
                                        $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-time-hidden" name="properties[Delivery-Time]" value="'+ ord_del_time +'">');
                                    }
                                }
                            });
                        }
                        //Change Variable Name
                        var str = parseInt(start_from);
                        if (parseInt(cutoff_status) == 1) {
                            //Check App Version if it is 3(i.e Enterprise) or more then it will Exceute Following Code For Multiple Cut Off and Delivery Time
                            if (app_version > 2 && type_of_app > 2) {
                                if (cutoff_global_status == 1 || data?.new_upgrade_status == 1) {
                                    cutoff_hours = cutoff_global_hours;
                                    cutoff_minute = cutoff_global_minute;
                                    // interval and cutoff local both
                                    if (app_config.global_product_cut_off == 0 && app_config.global_product_date_interval == 0) {
                                        if (parseInt(store_hour) <= parseInt(cutoff_hours)) {
                                            if (parseInt(store_hour) < parseInt(cutoff_hours)) {
                                                str = parseInt(product_settings.date_interval);
                                            } else {
                                                if (parseInt(store_hour) == parseInt(cutoff_hours) && parseInt(store_minute) < parseInt(cutoff_minute)) {
                                                    str = parseInt(product_settings.date_interval);
                                                } else {
                                                    str = parseInt(product_settings.date_interval) + 1;
                                                }
                                            }
                                        } else {
                                            str = parseInt(product_settings.date_interval + 1);
                                        }
                                    }
                                    // interval and cutoff global both
                                    else if (app_config.global_product_cut_off == 1 && app_config.global_product_date_interval == 1) {
                                        if (parseInt(store_hour) <= parseInt(cutoff_hours)) {
                                            if (parseInt(store_hour) < parseInt(cutoff_hours)) {
                                                str = parseInt(app_config.date_interval);
                                            } else {
                                                if (parseInt(store_hour) == parseInt(cutoff_hours) && parseInt(store_minute) < parseInt(cutoff_minute)) {
                                                    str = parseInt(app_config.date_interval);
                                                } else {
                                                    str = parseInt(app_config.date_interval + 1);
                                                }
                                            }
                                        } else {
                                            str = parseInt(app_config.date_interval + 1);
                                        }
                                    }
                                    // interval local and cutoff global
                                    else if (app_config.global_product_cut_off == 1 && app_config.global_product_date_interval == 0) {
                                        if (parseInt(store_hour) <= parseInt(cutoff_hours)) {
                                            if (parseInt(store_hour) < parseInt(cutoff_hours)) {
                                                str = parseInt(product_settings.date_interval);
                                            } else {
                                                if (parseInt(store_hour) == parseInt(cutoff_hours) && parseInt(store_minute) < parseInt(cutoff_minute)) {
                                                    str = parseInt(product_settings.date_interval);
                                                } else {
                                                    str = parseInt(product_settings.date_interval) + 1;
                                                }
                                            }
                                        } else {
                                            str = parseInt(product_settings.date_interval + 1);
                                        }
                                    }
                                    // interval global and cutoff local
                                    else {
                                        if (parseInt(store_hour) <= parseInt(cutoff_hours)) {
                                            if (parseInt(store_hour) < parseInt(cutoff_hours)) {
                                                str = parseInt(app_config.date_interval);
                                            } else {
                                                if (parseInt(store_hour) == parseInt(cutoff_hours) && parseInt(store_minute) < parseInt(cutoff_minute)) {
                                                    str = parseInt(app_config.date_interval);
                                                } else {
                                                    str = parseInt(app_config.date_interval + 1);
                                                }
                                            }
                                        } else {
                                            str = parseInt(app_config.date_interval + 1);
                                        }
                                    }
                                } else {
                                    var current_day = new Date().getDay();
                                    $zestard_jq.ajax({
                                        url: "https://ddp.zestardshop.com/get-cutoff-time",
                                        data: { day: current_day, shop_name: shop_name },
                                        async: false,
                                        success: function(response) {
                                            var json_data = JSON.parse(response);
                                            cutoff_hours = json_data['cutoff_hour'];
                                            cutoff_minute = json_data['cutoff_minute'];
                                        }
                                    });
                                    if (parseInt(store_hour) <= parseInt(cutoff_hours)) {
                                        if (parseInt(store_hour) < parseInt(cutoff_hours)) {
                                            str = parseInt(product_settings.date_interval);
                                        } else {
                                            if (parseInt(store_hour) == parseInt(cutoff_hours) && parseInt(store_minute) < parseInt(cutoff_minute)) {
                                                str = parseInt(product_settings.date_interval);
                                            } else {
                                                str = parseInt(product_settings.date_interval) + 1;
                                            }
                                        }
                                    } else {
                                        str = parseInt(product_settings.date_interval + 1);
                                    }
                                }
                            } else {
                                cutoff_hours = cutoff_global_hours;
                                cutoff_minute = cutoff_global_minute;
                                if (parseInt(store_hour) <= parseInt(cutoff_hours)) {
                                    if (parseInt(store_hour) < parseInt(cutoff_hours)) {
                                        str = parseInt(product_settings.date_interval);
                                    } else {
                                        if (parseInt(store_hour) == parseInt(cutoff_hours) && parseInt(store_minute) < parseInt(cutoff_minute)) {
                                            str = parseInt(product_settings.date_interval);
                                        } else {
                                            str = parseInt(product_settings.date_interval) + 1;
                                        }
                                    }
                                } else {
                                    str = parseInt(product_settings.date_interval + 1);
                                }
                            }
                        }

                        console.log("cutoff_global_hours + cutoff_global_minute AFTER");
                        console.log(cutoff_hours,cutoff_minute);

                        if (product_settings.product_based_settings == 1) {
                        				str = str + parseInt(product_settings.date_interval); 
                        			}
                        start_from = '+' + parseInt(str);
                        
                        original_start_from = start_from;
                        function pad(n) {
                            return (n < 10) ? ("0" + n) : n;
                        }
                        var tempdate = new Date();
                        tempdate.setDate(tempdate.getDate());
                        var weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                        var block_date_array = blocked_dates.split(",");
                        if (current_day != null) {
                            var block_days_array = current_day.toString().split(",");
                        } else {
                            block_days_array = new Array()
                        }
                        var block_days_array = unavailableDays;
                        var NextDayDMY = pad(current_day) + '-' + pad(month) + '-' + year;
                        var NextDayYMD = year + '-' + pad(month) + '-' + pad(current_day);
                        var current_available_day = weekday[tempdate.getDay()];
                        exit_flag = 0;
                        temp_count = start_from;
                        if (!block_days_array) {
                            block_days_array = new Array();
                        }
                        if (!block_date_array) {
                            block_date_array = new Array();
                        }
                        if (parseInt(data.exclude_block_date_status) == 1) {
                            if (temp_count == 0) {
                                if (block_date_array.length > 0 || block_days_array.length > 0) {
                                    while (temp_count == 0) {
                                        var date = tempdate.getDate();
                                        var month = tempdate.getMonth() + 1;
                                        var year = tempdate.getFullYear();
                                        NextDayDMY = pad(date) + '-' + pad(month) + '-' + year;
                                        NextDayYMD = year + '-' + pad(month) + '-' + pad(date);
                                        current_available_day = weekday[tempdate.getDay()];

                                        if ($zestard_jq.inArray(NextDayDMY, block_date_array) !== -1) {
                                            index_of = block_date_array.indexOf(NextDayDMY);
                                            block_date_array.splice(index_of, 1);
                                            start_from = parseInt(start_from) + 1;
                                            temp_count = start_from;
                                        } else if ($zestard_jq.inArray(current_available_day, block_days_array) !== -1) {
                                            index_of = block_days_array.indexOf(current_available_day);
                                            var current_date = new Date();
                                            //block_days_array.splice(index_of, 1);
                                            start_from = (parseInt(start_from) > 1 || (parseInt(start_from) == 1 && weekday[current_date.getDay()] == current_available_day)) ? (parseInt(start_from) + 1) : parseInt(start_from);
                                            temp_count = start_from;
                                        } else {
                                            if (block_date_array.length <= 0 || block_days_array.length <= 0) {
                                                temp_count = -1;
                                            } else if (temp_count == 0) {
                                                temp_count = -1;
                                            } else {
                                                temp_count--;
                                            }
                                        }
                                        tempdate.setDate(tempdate.getDate() + 1);
                                    }
                                }
                            } else {
                                while ((block_date_array.length > 0 || block_days_array.length > 0) && temp_count > -1) {
                                    var date = tempdate.getDate();
                                    var month = tempdate.getMonth() + 1;
                                    var year = tempdate.getFullYear();
                                    NextDayDMY = pad(date) + '-' + pad(month) + '-' + year;
                                    NextDayYMD = year + '-' + pad(month) + '-' + pad(date);
                                    current_available_day = weekday[tempdate.getDay()];
                                    if ($zestard_jq.inArray(NextDayDMY, block_date_array) !== -1) {
                                        temp_count = 0;
                                        index_of = block_date_array.indexOf(NextDayDMY);
                                        block_date_array.splice(index_of, 1);
                                        start_from = parseInt(start_from) + 1;
                                        temp_count = start_from;

                                    } else if ($zestard_jq.inArray(current_available_day, block_days_array) !== -1) {
                                        index_of = block_days_array.indexOf(current_available_day);
                                        temp_count = 0;
                                        var current_date = new Date();
                                        //block_days_array.splice(index_of, 1);
                                        if (shop_name == "lov-flowers-uk.myshopify.com"){
                                            var dynamic_date = new Date();
                                            dynamic_date.setDate(current_date.getDate() + parseInt(start_from));
                                            start_from = (parseInt(start_from) > 1 || (parseInt(start_from) == 1 && weekday[current_date.getDay()] == current_available_day) || (parseInt(start_from) == 1 && $zestard_jq.inArray(current_available_day, block_days_array) && current_available_day == weekday[dynamic_date.getDay()])) ? (parseInt(start_from) + 1) : parseInt(start_from);
                                        }else{
                                            start_from = (parseInt(start_from) > 1 || (parseInt(start_from) == 1 && weekday[current_date.getDay()] == current_available_day)) ? (parseInt(start_from) + 1) : parseInt(start_from);
                                        }
                                        temp_count = start_from;
                                        // console.log(weekday,weekday[current_date.getDay()],current_available_day,tempdate.getDay(),block_days_array,$zestard_jq.inArray(current_available_day, block_days_array),temp_count)

                                    } else {

                                        /* 1 Aug 2018 */
                                        var start_from_date = new Date();
                                        start_from_date.setDate(start_from_date.getDate() + parseInt(original_start_from));
                                        if (tempdate.getTime() >= start_from_date.getTime()) {
                                            temp_count = -1;
                                            block_days_array = [];
                                        }

                                    }
                                    tempdate.setDate(tempdate.getDate() + 1);

                                }
                            }
                        }
                        if (parseInt(data.exclude_block_date_status) == 1 && 1 == 2) {
                            var block_date_array = JSON.parse(blocked_dates);
                            var block_days_array = JSON.parse(current_day);
                            var ddmmyy = $zestard_jq("#ztpl-date-format-ddmmyy").val();
                            var yymmdd = $zestard_jq("#ztpl-date-format-yymmdd").val();
                            var date_index = parseInt(0);
                            var reloop = function(ddmmyy, yymmdd) {
                                var weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                                var current_day = new Date(yymmdd);
                                var current_available_day = weekday[current_day.getDay()];
                                //if(jQuery.inArray(ddmmyy,block_date_array) !== -1)
                                //Here ddmmyy
                                if ($zestard_jq.inArray(ddmmyy, block_date_array) != -1) {
                                    start_from = parseInt(start_from) + 1;
                                    //And Here yymmdd??
                                    var NextDayData = new Date(new Date(yymmdd).getFullYear(), new Date(yymmdd).getMonth(), new Date(yymmdd).getDate() + 1);
                                    var next_date = new Date(NextDayData).getDate();
                                    var month = new Date(NextDayData).getMonth() + 1;
                                    var year = new Date(NextDayData).getFullYear();
                                    var NextDayDMY = pad(next_date) + '-' + pad(month) + '-' + year;
                                    var NextDayYMD = year + '-' + pad(month) + '-' + pad(next_date);
                                    //alert(NextDayDMY+'=='+NextDayYMD);
                                    return reloop(NextDayDMY, NextDayYMD);
                                } else if ($zestard_jq.inArray(current_available_day, block_days_array) != -1) {
                                    start_from = parseInt(start_from) + 1;
                                    //alert('days== '+start_from);
                                    var NextDayData = new Date(new Date(yymmdd).getFullYear(), new Date(yymmdd).getMonth(), new Date(yymmdd).getDate() + 1);
                                    var next_date = new Date(NextDayData).getDate();
                                    var month = new Date(NextDayData).getMonth() + 1;
                                    var year = new Date(NextDayData).getFullYear();
                                    var NextDayDMY = pad(next_date) + '-' + pad(month) + '-' + year;
                                    var NextDayYMD = year + '-' + pad(month) + '-' + pad(next_date);
                                    return reloop(NextDayDMY, NextDayYMD);
                                }
                            }
                            reloop(ddmmyy, yymmdd);
                            //alert('total== '+start_from);
                            function pad(n) {
                                return (n < 10) ? ("0" + n) : n;
                            }
                        }
                        var additional_css = data.additional_css;
                        $zestard_jq('.additional-css').after("<style>" + additional_css + "</style>");
                        setTimeout(function() {
                            var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                            var ymd, ymd1;
                            var highlight_flag = 1;

                    
                            function detectDateFormat(date, fallbackFormat = "dd-mm-yyyy") {
                                // Detects the date format: "dd-mm-yyyy", "mm/dd/yyyy", "mm-dd-yyyy", "yyyy-mm-dd", or "dd/mm/yyyy"
                                const parts = date.split(/[-\/]/);
                            
                                if (date.includes("-")) {
                                    if (parts[0].length === 4) {
                                        return "yyyy-mm-dd";
                                    } else if (parts[2].length === 4) {
                                        if (parseInt(parts[0]) > 12) {
                                            return "dd-mm-yyyy";
                                        } else if (parseInt(parts[1]) > 12) {
                                            return "mm-dd-yyyy";
                                        } else {
                                            return fallbackFormat;
                                        }
                                    }
                                } else if (date.includes("/")) {
                                    if (parts[2].length === 4) {
                                        if (parseInt(parts[0]) > 12) {
                                            return "dd/mm/yyyy";
                                        } else {
                                            return "mm/dd/yyyy";
                                        }
                                    } else {
                                        return fallbackFormat;
                                    }
                                }
                            
                                return fallbackFormat; // Default to fallback format for unknown cases
                            }
                            
                            function normalizeDateToDDMMYYYY(date, format) {
                                const parts = date.split(/[-\/]/);
                                switch (format) {
                                    case "mm/dd/yyyy":
                                    case "mm-dd-yyyy":
                                        return `${("0" + parts[1]).slice(-2)}-${("0" + parts[0]).slice(-2)}-${parts[2]}`;
                                    case "dd/mm/yyyy":
                                    case "dd-mm-yyyy":
                                        return `${("0" + parts[0]).slice(-2)}-${("0" + parts[1]).slice(-2)}-${parts[2]}`;
                                    case "yyyy-mm-dd":
                                        return `${("0" + parts[2]).slice(-2)}-${("0" + parts[1]).slice(-2)}-${parts[0]}`;
                                    default:
                                        return date; // Return as-is for unknown formats
                                }
                            }
                            
                            function formatDateToDDMMYYYY(date, format) {
                                const day = ("0" + date.getDate()).slice(-2);
                                const month = ("0" + (date.getMonth() + 1)).slice(-2);
                                const year = date.getFullYear();
                            
                                return `${day}-${month}-${year}`;
                            }
                            
                            function unavailable(date) {
                                const ymd1 = formatDateToDDMMYYYY(date); // Normalize to dd-mm-yyyy
                                const day = new Date(date).getDay();
                            
                                // Normalize unavailableDates dynamically based on detected format
                                const normalizedUnavailableDates = unavailableDates.map(d => {
                                    const detectedFormat = detectDateFormat(d, "dd-mm-yyyy");
                                    return normalizeDateToDDMMYYYY(d, detectedFormat);
                                });
                            
                                console.log("Normalized Unavailable Dates:", normalizedUnavailableDates);
                                console.log("Current Date (ymd1):", ymd1);
                            
                                if (
                                    $zestard_jq.inArray(ymd1, normalizedUnavailableDates) < 0 &&
                                    $zestard_jq.inArray(days[day], unavailableDays) < 0
                                ) {
                                    return [true, "enabled", "Book Now"];
                                } else {
                                    return [false, "disabled", "Booked Out"];
                                }
                            }

                            setTimeout(function() {
                                datepicker_var = undefined;
                                //For keeping datepicker always open
                                if (datepicker_on_default == 1) {
                                    if (locale == "en") {
                                        $zestard_jq("#datepicker_box .date-box").append("<div class='visible_datepicker'></div>");
                                        $zestard_jq("#delivery-date-pro").attr("type", "hidden");
                                        $zestard_jq("#datepicker_box_jquery").css("visibility", "hidden");
                                        datepicker_var = $zestard_jq(".visible_datepicker").datepicker({
                                            dateFormat: 'dd-mm-yy',
                                            minDate: parseInt(start_from),
                                            maxDate: allowed_month,
                                            onSelect: function(dateText) {
                                                if($zestard_jq("[action='/cart/add']").length > 0){
                                                    if (shop_name == "morimoto-gift.myshopify.com"){
                                                        $zestard_jq(".delivery-date-hidden").remove();
                                                        $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-date-hidden" name="properties[é…é€æ—¥]" value="'+ dateText +'">');
                                                    }else{
                                                        $zestard_jq(".delivery-date-hidden").remove();
                                                        $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-date-hidden" name="properties[Delivery-Date]" value="'+ dateText +'">'); 
                                                    } 
                                                }
                                                $zestard_jq('#AddToCart').prop('disabled', false);
                                                $zestard_jq('.zAddToCart').prop('disabled', false);
                                                if($zestard_jq("#delivery-day").length > 0){

                                                    var newformat1 = dateText.split("/");
                                                    newformat = dateText;
                                                     if (date_formate == "dd/mm/yy") {
                                                        var newformat = newformat1[1]+"/"+newformat1[0]+"/"+newformat1[2];
                                                    }
                                                    var day_weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
                                                    var a = new Date(newformat);
                                                    console.log(day_weekday[a.getDay()]);
                                                    var my_day = day_weekday[a.getDay()];
                                                    $zestard_jq("#delivery-day").val(my_day);
                                                }

                                            },
                                            beforeShowDay: unavailable,
                                            beforeShow: function() {
                                                setTimeout(function() {
                                                    $zestard_jq('.ui-datepicker').css('z-index', 99999999999999);
                                                }, 0);
                                            }
                                        });
                                    } else {
                                        console.log($zestard_jq.datepicker);
                                        $zestard_jq("#datepicker_box .date-box").append("<div class='visible_datepicker'></div>");
                                        $zestard_jq("#delivery-date-pro").attr("type", "hidden");
                                        $zestard_jq("#datepicker_box_jquery").css("visibility", "hidden");
                                        datepicker_var = $zestard_jq(".visible_datepicker").datepicker( //$zestard_jq.datepicker.regional[locale],
                                            {
                                                dateFormat: 'dd-mm-yy',
                                                minDate: start_from,
                                                maxDate: "'" + allowed_month + "'",
                                                onSelect: function(dateText) {
                                                    if($zestard_jq("[action='/cart/add']").length > 0){
                                                        if (shop_name == "morimoto-gift.myshopify.com"){
                                                            $zestard_jq(".delivery-date-hidden").remove();
                                                            $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-date-hidden" name="properties[é…é€æ—¥]" value="'+ dateText +'">');
                                                        }else{
                                                            $zestard_jq(".delivery-date-hidden").remove();
                                                            $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-date-hidden" name="properties[Delivery-Date]" value="'+ dateText +'">');
                                                        }  
                                                    }
                                                    $zestard_jq('#AddToCart').prop('disabled', false);
                                                    $zestard_jq('.zAddToCart').prop('disabled', false);
                                                     if($zestard_jq("#delivery-day").length > 0){

                                                        var newformat1 = dateText.split("/");
                                                        newformat = dateText;
                                                         if (date_formate == "dd/mm/yy") {
                                                            var newformat = newformat1[1]+"/"+newformat1[0]+"/"+newformat1[2];
                                                        }
                                                        var day_weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
                                                        var a = new Date(newformat);
                                                        console.log(day_weekday[a.getDay()]);
                                                        var my_day = day_weekday[a.getDay()];
                                                        $zestard_jq("#delivery-day").val(my_day);
                                                    }
                                                },
                                                beforeShowDay: unavailable,
                                                beforeShow: function() {
                                                    setTimeout(function() {
                                                        $zestard_jq('.ui-datepicker').css('z-index', 99999999999999);
                                                    }, 0);
                                                }
                                            });
                                        $zestard_jq.datepicker.setDefaults($zestard_jq.datepicker.regional[locale]);
                                        //$zestard_jq(".visible_datepicker").datepicker($zestard_jq.datepicker.regional[locale]);
                                    }
                                } else {
                                    if (locale == "en") {
                                        datepicker_var = $zestard_jq("#delivery-date-pro").datepicker({
                                            dateFormat: 'dd-mm-yy',
                                            minDate: start_from,
                                            maxDate: "'" + allowed_month + "'",
                                            onSelect: function(dateText) {
                                                if($zestard_jq("[action='/cart/add']").length > 0){
                                                    if (shop_name == "morimoto-gift.myshopify.com"){
                                                        $zestard_jq(".delivery-date-hidden").remove();
                                                        $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-date-hidden" name="properties[é…é€æ—¥]" value="'+ dateText +'">');
                                                    }else{
                                                        if(shop_name == '244187-96.myshopify.com'){
                                                            event.preventDefault();
                                                            $zestard_jq('#addToCart').addClass('js-ajax-submit');
                                                            $zestard_jq('#addToCart').removeClass('disabled');
                                                            $zestard_jq('#addToCart').attr('value','Add to Cart');
                                                            // console.log(shop_name);
                                                            // event.stopPropagation();
                                                        }
                                                        console.log(shop_name,'else');
                                                        if(shop_name == "lov-flowers-uk.myshopify.com"){
                                                            if($zestard_jq("[action='/cart/add']").find('.delivery-date-hidden').length > 0 && $zestard_jq("[action='/cart/add']").find('#delivery-date-pro').length > 0){
                                                                $zestard_jq(".delivery-date-hidden").remove();
                                                            }else if($zestard_jq("[action='/cart/add']").find('.delivery-date-hidden').length  == 0 && $zestard_jq("[action='/cart/add']").find('#delivery-date-pro').length  == 0) {
                                                                $zestard_jq(".delivery-date-hidden").remove();
                                                                $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-date-hidden" name="properties[Delivery-Date]" value="'+ dateText +'">');
                                                            }
                                                        }else{                                                        
                                                            $zestard_jq(".delivery-date-hidden").remove();
                                                            $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-date-hidden" name="properties[Delivery-Date]" value="'+ dateText +'">');
                                                        }
                                                    }  
                                                }
                                                $zestard_jq('#AddToCart').prop('disabled', false);
                                                $zestard_jq('.zAddToCart').prop('disabled', false);
                                                 if($zestard_jq("#delivery-day").length > 0){

                                                    var newformat1 = dateText.split("/");
                                                    newformat = dateText;
                                                     if (date_formate == "dd/mm/yy") {
                                                        var newformat = newformat1[1]+"/"+newformat1[0]+"/"+newformat1[2];
                                                    }
                                                    var day_weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
                                                    var a = new Date(newformat);
                                                    console.log(day_weekday[a.getDay()]);
                                                    var my_day = day_weekday[a.getDay()];
                                                    $zestard_jq("#delivery-day").val(my_day);
                                                }
                                            },
                                            beforeShowDay: unavailable,
                                            defaultDate: null,
                                            beforeShow: function() {
                                                setTimeout(function() {
                                                    $zestard_jq('.ui-datepicker').css('z-index', 99999999999999999999);
                                                }, 500);
                                            }
                                        });
                                    } else {
                                        datepicker_var = $zestard_jq("#delivery-date-pro").datepicker({
                                            dateFormat: 'dd-mm-yy',
                                            minDate: start_from,
                                            maxDate: "'" + allowed_month + "'",
                                            onSelect: function(dateText) {
                                                if($zestard_jq("[action='/cart/add']").length > 0){
                                                    if (shop_name == "morimoto-gift.myshopify.com"){
                                                        $zestard_jq(".delivery-date-hidden").remove();
                                                        $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-date-hidden" name="properties[é…é€æ—¥]" value="'+ dateText +'">');
                                                    }else{
                                                        $zestard_jq(".delivery-date-hidden").remove();
                                                        $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-date-hidden" name="properties[Delivery-Date]" value="'+ dateText +'">'); 
                                                    } 
                                                }
                                                $zestard_jq('#AddToCart').prop('disabled', false);
                                                $zestard_jq('.zAddToCart').prop('disabled', false);
                                                 if($zestard_jq("#delivery-day").length > 0){

                                                    var newformat1 = dateText.split("/");
                                                    newformat = dateText;
                                                     if (date_formate == "dd/mm/yy") {
                                                        var newformat = newformat1[1]+"/"+newformat1[0]+"/"+newformat1[2];
                                                    }
                                                    var day_weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
                                                    var a = new Date(newformat);
                                                    console.log(day_weekday[a.getDay()]);
                                                    var my_day = day_weekday[a.getDay()];
                                                    $zestard_jq("#delivery-day").val(my_day);
                                                }
                                            },
                                            beforeShowDay: unavailable,
                                            beforeShow: function() {
                                                setTimeout(function() {
                                                    $zestard_jq('.ui-datepicker').css('z-index', 99999999999999);
                                                }, 0);
                                            }
                                        });
                                        $zestard_jq.datepicker.setDefaults($zestard_jq.datepicker.regional[locale]);
                                    }
                                    if (datepicker_default_date == 1 || shop_name == 'the-little-market-bunch.myshopify.com') {
                                        datepicker_var.datepicker("setDate", start_from);
                                    }
                                }
                            }, 200);
                            if (shop_name == "purpinkg.myshopify.com" || shop_name == "morimoto-gift.myshopify.com") {
                                setTimeout(function() {
                                    $zestard_jq('.visible_datepicker').datepicker("setDate", null);
                                }, 500);
                            }
                            // Check If Datepicker Object is Undefined
                            if (app_version > 1 && type_of_app > 1) {
                                if (datepicker_default_date == 1) {
                                    $zestard_jq("#delivery-date-pro").datepicker("setDate", "today + start_from");
                                }
                            }
                            // if (typeof datepicker_var === 'undefined') {
                                //If Undefined, Then send email
                                // $zestard_jq.ajax({
                                //     url: "https://ddp.zestardshop.com/acknowledge",
                                //     async: false,
                                //     data: { shop_name: shop_name, type: 3 },
                                //     success: function(result) {

                                //     }
                                // });
                            // }
                            // }, 300)
                            $zestard_jq("#delivery-date-pro").prop("disabled", false);
                        });

                        //Check App Version if it is 3(i.e Enterprise) or more then it will Exceute Following Code For Multiple Cut Off and Delivery Time
                        if (app_version > 2 && type_of_app > 2) {
                            if (deliverytime_global_status == 0) {
                                delivery_date_pro();
                                var result = "";
                                $zestard_jq.ajax({
                                    url: "https://ddp.zestardshop.com/delivery-times",
                                    data: { shop_name: shop_name, start_from: start_from, date_format: date_formate, product_id: DDP_product_id, global_time: app_config.global_product_delivery_time },
                                    async: false,
                                    success: function(response) {
                                        if (response == 0) {
                                            $zestard_jq("#delivery-time").html("");
                                        } else {
                                            $zestard_jq("#delivery-time").html("");
                                            $zestard_jq("#delivery-time").append("<option value=''>Choose Time</option>");
                                            for (var key in response) {
                                                $zestard_jq("#delivery-time").append("<option value='" + response[key] + "'> " + response[key] + " </option>");
                                            }
                                        }
                                    }

                                });
                            } else {
                                $zestard_jq(time_array).each(function() {
                                    $zestard_jq('#delivery-time').append("<option value='" + time_array[time_count] + "'" + ">" + time_array[time_count] + "</option>");
                                    time_count++;
                                });
                            }
                        }
                        setTimeout(function() {
                            $zestard_jq("input[name=add]").css('pointer-events', "auto");
                            $zestard_jq("button[name=add]").css('pointer-events', "auto");
                            $zestard_jq("#AddToCart").css('pointer-events', "auto");
                        }, 3000);
                        setTimeout(function() {
                            old_order_note = $zestard_jq('textarea[name=note]').val();
                            if (old_order_note) {
                                open_index = old_order_note.indexOf("(Delivery Date:");
                                if (open_index > -1) {
                                    $zestard_jq('textarea[name=note]').val(old_order_note.substring(0, open_index - 1));
                                }
                            }
                        }, 500);
                        var myTime = setInterval(function() {
                            // console.log($zestard_jq('button[name=add]').length,'length');
                            if($zestard_jq('input[name=add], button[name=add], #AddToCart, .js-ajax-submit').length > 0){
                                $zestard_jq('input[name=add], button[name=add], #AddToCart, .js-ajax-submit').off('click');
                                $zestard_jq('input[name=add], button[name=add], #AddToCart, .js-ajax-submit').on('click', function(event) {
                                    if (datepicker_on_default == 1) {
                                        var temp_date = $zestard_jq(".visible_datepicker").val();
                                        /*if($zestard_jq("[action='/cart/add']").length > 0){
                                            if($zestard_jq("[action='/cart/add']").find('.delivery-date-hidden').length == 0){
                                                $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-date-hidden" name="attributes[Delivery-Date]" value="'+ temp_date +'">');
                                            }
                                        }*/
                                        // console.log(is_date_required,$zestard_jq('#delivery-date-pro').val(),temp_date);
                                        $zestard_jq("#delivery-date-pro").val(temp_date);
                                    }
                                    // (temp_date);
                                    order_note = '';
                                    old_order_note = '';
                                    if (app_status == 'Active') {
                                        if (is_date_required == true && ((typeof $zestard_jq('#delivery-date-pro').val() == 'undefined') || ($zestard_jq('#delivery-date-pro').val() == ''))) {
                                            alert(date_error_message);
                                            if(shop_name == '244187-96.myshopify.com'){
                                                event.preventDefault();
                                                $zestard_jq('#addToCart').removeClass('js-ajax-submit');
                                                $zestard_jq('#addToCart').attr('value','Add to Cart');
                                                console.log(shop_name);
                                                // event.stopPropagation();
                                            }
                                            $zestard_jq('#delivery-date-pro').focus();
                                            return false;
                                        }
                                        
                                        if (is_time_required == true && ((typeof $zestard_jq('#delivery-time').val() == 'undefined') || ($zestard_jq('#delivery-time').val() == ''))) {
                                            if(product_status == 1){
                                                alert(time_error_message);
                                                $zestard_jq('#delivery-time').focus();
                                                return false;
                                            }
                                        }
                                        
                                        if (add_delivery_information == 1) {
                                            order_note = $zestard_jq('textarea[name=note]').val();
                                            old_order_note = $zestard_jq('textarea[name=note]').val();
                                        }
                                        //Check Blocked Days and Dates
                                        if ($zestard_jq('#delivery-date-pro').val() != '') {
                                            selected_delivery_date = $zestard_jq('#delivery-date-pro').val();
                                            if (datepicker_on_default == 1) {
                                                selected_delivery_date = $zestard_jq(".visible_datepicker").val();
                                            }
                                            // if (shop_name == "debut-shopify.myshopify.com") {
                                            //     if (date_formate == "dd/mm/yy") {
                                            //         formatted_delivery_date = selected_delivery_date;
                                            //     }
                                            //     if (date_formate == "mm/dd/yy") {
                                            //         delivery_date_array = selected_delivery_date.split('/');
                                            //         formatted_delivery_date = delivery_date_array[1] + '/' + delivery_date_array[0] + '/' + delivery_date_array[2];
                                            //     }
                                            //     if (date_formate == "yy/mm/dd") {

                                            //         delivery_date_array = selected_delivery_date.split('/');
                                            //         formatted_delivery_date = delivery_date_array[2] + '/' + delivery_date_array[1] + '/' + delivery_date_array[0];
                                            //     }
                                            // }
                                            formatted_delivery_date = selected_delivery_date;
                                            if (app_version > 2 && type_of_app > 2) {
                                                if (shop_name == "apps-testing-store.myshopify.com" || shop_name == "the-bunched-co.myshopify.com") {
                                                    if (delivery_info.length > 0) {
                                                        $zestard_jq.ajax({
                                                            url: "https://ddp.zestardshop.com/check-cart",
                                                            data: { delivery_info: JSON.stringify(delivery_info), delivery_time: $zestard_jq("#delivery-time").val(), date_format: date_formate, delivery_date: formatted_delivery_date, shop_name: shop_name },
                                                            async: false,
                                                            success: function(result) {
                                                                if (result == 1) {

                                                                } else {
                                                                    alert("Selected Delivery Time Slot is Full. Please Select Other Delivery Time");
                                                                    event.preventDefault();
                                                                }
                                                            }
                                                        });
                                                    }
                                                }
                                            }
                                            var blocked_status, json_response, blocked_date_status;
                                            var todays_date = $zestard_jq('#delivery-date-pro').val();
                                            var today = new Date(todays_date).getDay();
                                            //no need for Ultimate version
                                            // $zestard_jq.ajax({
                                            //     url: "https://ddp.zestardshop.com/check-blocked-day",
                                            //     data: { todays_date: todays_date, date_format: date_formate, shop_name: Shopify.shop },
                                            //     async: false,
                                            //     success: function(result) {
                                            //         json_response = $zestard_jq.parseJSON(result);
                                            //     }
                                            // });
                                            // blocked_status = json_response.result;
                                            // $zestard_jq.ajax({
                                            //     url: "https://ddp.zestardshop.com/check-blocked-date",
                                            //     data: { delivery_date: todays_date, date_format: date_formate, shop_name: Shopify.shop },
                                            //     async: false,
                                            //     success: function(response) {
                                            //         blocked_date_status = response;
                                            //     }
                                            // });
                                            // if (app_config.global_product_blocked_days == 1 && blocked_status == 0) {
                                            //     alert('Sorry Delivery is Not Possible for ' + json_response.today + ' . Please Select Other Day');
                                            //     event.preventDefault();
                                            // }
                                            // if (app_config.global_product_blocked_dates == 1 && blocked_date_status == 0) {
                                            //     alert('Sorry, The Delivery Date You Selected is Blocked. Please Select Other Delivery Date');
                                            //     event.preventDefault();
                                            // }
                                            if (blocked_date_status == 1 && blocked_status == 1) {
                                                $zestard_jq.ajax({
                                                    url: "https://ddp.zestardshop.com/check-cuttoff",
                                                    data: { start_from: start_from, date_format: date_formate, store_date: store_date, delivery_date: formatted_delivery_date, store_hour: store_hour, store_minute: store_minute, shop_name: shop_name },
                                                    async: false,
                                                    success: function(result) {
                                                        cutoff_response = result;
                                                    }
                                                });
                                                if (add_delivery_information == 1) {
                                                    order_note = order_note + " (Delivery Date: " + $zestard_jq('#delivery-date-pro').val();
                                                    if ($zestard_jq('#delivery-time').val() != '') {
                                                        order_note = order_note + ", Delivery Time: " + $zestard_jq('#delivery-time').val() + ")";
                                                    }
                                                    $zestard_jq('textarea[name=note]').val(order_note);
                                                }
                                                if (cutoff_response == 1) {
                                                    if ($zestard_jq("#delivery-time").val() == "" || typeof $zestard_jq('#delivery-date-pro').val() === 'undefined') {
                                                        if (is_time_required == true && product_status == 1) {
                                                            alert("Please Select Delivery Time");
                                                            $zestard_jq('#delivery-time').focus();
                                                            event.preventDefault();
                                                            return false;
                                                        }
                                                    } else {
                                                        if (deliverytime_global_status == 0) {
                                                            $zestard_jq.ajax({
                                                                url: "https://ddp.zestardshop.com/check-delivery-time",
                                                                data: { delivery_time: $zestard_jq("#delivery-time").val(), date_format: date_formate, delivery_date: formatted_delivery_date, shop_name: shop_name },
                                                                async: false,
                                                                success: function(result) {
                                                                    deliverytime_response = result;
                                                                }
                                                            });
                                                            if (deliverytime_response == 1) {

                                                            } else {
                                                                alert("Selected Delivery Time Slot is Full. Plese Select Other Delivery Time");
                                                                event.preventDefault();
                                                            }
                                                        }
                                                    }
                                                }
                                                if (cutoff_response == 0) {
                                                    if(product_status == 1){
                                                        alert("Cut Off Time is Over Please Select Other Delivery Date");
                                                        event.preventDefault();
                                                    }
                                                }
                                                if (cutoff_response == 2) {
                                                    if(product_status == 1){
                                                        alert("Sorry You Cannot Select " + $zestard_jq("#delivery-date-pro").val() + " As Delivery Date");
                                                        event.preventDefault();
                                                    }
                                                }
                                                if(datepicker_default_date == 1){
                                                    var temp_date = $zestard_jq("#delivery-date-pro").val();
                                                    if($zestard_jq("[action='/cart/add']").length > 0){
                                                        $zestard_jq(".delivery-date-hidden").remove();
                                                        if(shop_name == 'beverly-fleur.myshopify.com' || shop_name == `amit-test-store1.myshopify.com`){
                                                            console.log('if code called');
                                                            $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-date-hidden" name="properties[Delivery-Date]" value="'+ temp_date +'">');
                                                        }else{
                                                            if(shop_name == 'the-little-market-bunch.myshopify.com'){
                                                                $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-date-hidden" name="attributes[Delivery-Date]" value="'+ temp_date +'">');
                                                            }else{
                                                                $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-date-hidden" name="properties[Delivery-Date]" value="'+ temp_date +'">');
                                                            }
                                                          //  $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-date-hidden" name="attributes[Delivery-Date]" value="'+ temp_date +'">');
                                                          //hidden above line 15 30th jan 2025 for same delivery date for multiple products
                                                            //  $zestard_jq("[action='/cart/add']").append('<input type="hidden" class="delivery-date-hidden" name="properties[Delivery-Date]" value="'+ temp_date +'">');
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                });
                                clearInterval(myTime)
                            }
                        },200);
                    }
                }
            });
        }
    } catch(e){
        e.message = 'Error occurred in product snippets file DeliveryDatePro function. Error -'+e.message;
        fn_exception_occurred_call(shop_name,e);
    }
}
//Following Function is for Showing Delivery Time Dynamically Based on Days
function delivery_date_pro() {
    var day;
    $zestard_jq("#delivery-date-pro").change(function(dateText) {
        var result = "";
        day = new Date(this.value).getDay();
        $zestard_jq.ajax({
            url: "https://ddp.zestardshop.com/delivery-times",
            data: { todays_date: this.value, date_format: date_formate, shop_name: shop_name },
            async: false,
            success: function(response) {
                if (response == 0) {
                    $zestard_jq("#delivery-time").html("");
                    if (is_time_required == true) {
                        alert('Sorry No Time Slots Available For ' + $zestard_jq("#delivery-date-pro").val() + ' Please Select Other Date');
                        $zestard_jq("#delivery-date-pro").val("");
                        $zestard_jq("#delivery-date-pro").focus();
                    }
                } else {
                    $zestard_jq("#delivery-time").html("");
                    $zestard_jq("#delivery-time").append("<option value=''>Choose Time</option>");
                    for (var key in response) {
                        $zestard_jq("#delivery-time").append("<option value='" + response[key] + "'> " + response[key] + " </option>");
                    }
                }
            }
        });
    });
}
